import {ObjectNumber} from 'gollumts-objecttype';
import {RegisteredInterface} from './models/RegisteredInterface';

class Manager {
	
	private _idGlobal: number = 0;
	private _registeds: ObjectNumber<RegisteredInterface> = {};
	
	public clear() {
		this.registeds.forEach(o => this.unregister(o));
		this._idGlobal = 0;
		this._registeds = {};
	};
	
	public register(obj: RegisteredInterface): RegisteredInterface {
		if (!obj.id) {
			obj.id = ++this._idGlobal;
		}
		if (!this._registeds[obj.id]) {
			this._registeds[obj.id] = obj;
		}
		return this._registeds[obj.id];
	}
	
	public unregister(obj: RegisteredInterface): RegisteredInterface {
		if (obj.id) {
			if (this._registeds[obj.id]) {
				obj = this._registeds[obj.id];
				delete(this._registeds[obj.id]);
				obj.id = null;
			}
		}
		return obj;
	}
	
	public get idGlobal(): number {
		return this._idGlobal;
	}
	
	public set idGlobal(value: number) {
		this._idGlobal = value;
	}
	
	public get registeds(): RegisteredInterface[] {
		return Object.keys(this._registeds).map(k => this._registeds[k]);
	}
	
	public find(id: number): any {
		return this._registeds[id];
	}
	
}

const manager = new Manager();
export default manager;